/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import {Injectable} from '@angular/core';
import {SearchableProvider} from '../model/interface/searchable.provider';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/internal/Observable';
import {Franchise, RestResponse} from '../model';
import {environment} from '../../environments/environment';
import {ApiHeaders} from './headers';
import { SystemType } from '../model/enums/system.type';

@Injectable()
export class RMAProvider{

  constructor(
    private http: HttpClient
  ) {
  }

 

  getRma( id?:string, region? : string): Observable<any> {
    return this.http
      .get(`${environment.API_URL}/api/industry/rma/${id}?region=${region}`, ApiHeaders.getOptions());
  }
 
  postRma(data: FormData): Observable<any> {
    return this.http.post(`${environment.API_URL}/api/industry/file/rma/parse`, data);
  }

  search(query?: string, id?: string, nonBank?: boolean, lsp?: boolean, page?: number , position?: string, type?: SystemType , region? : string  ) : Observable<RestResponse> {
    return this.getRma(id , region);
  }

  getSearchType(): string {
    return 'RMA';
  }
 
}
